import React from 'react';

const SvgInvitationSent: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 -1 24 24" fill="none" {...props}>
    <path
      d="M19.2245 4.03254C19.4358 3.95868 19.6706 4.01294 19.8288 4.17119C19.9871 4.32945 20.0413 4.56422 19.9675 4.77548L14.7752
      19.6094C14.6962 19.835 14.4872 19.9898 14.2485 19.9995C14.0396 20.0079 13.8446 19.9039 13.7342 19.7315L13.6928
      19.6539L10.8163 13.1827L4.34607 10.3072L4.26847 10.2658C4.0961 10.1554 3.99209 9.96035 4.00047 9.75152C4.01021 9.51277
      4.16504 9.30377 4.39057 9.22484L19.2245 4.03254ZM11.9524 12.8702L14.1605 17.8369L18.0222 6.80045L11.9524 12.8702ZM6.16203
      9.83843L11.1288 12.0466L17.1985 5.9768L6.16203 9.83843Z"
      fill="#428FEF"
    />
  </svg>
);

export default SvgInvitationSent;
